/* eslint-disable no-extra-boolean-cast */

/* eslint-disable no-nested-ternary */
import PropTypes from "prop-types"
import React from "react"
import { useDispatch } from "react-redux"
import Permissions from "react-redux-permissions"
import { NavLink } from "react-router-dom"

import { useTranslate } from "context/translateContext"
import { GENERAL_TOGGLE_MAIN_NAVIGATION } from "data/constants"

import styles from "./MenuEntry.module.css"

export default function MenuFactory(props) {
  const dispatch = useDispatch()
  const {
    entry,
    depth,
    activePlatform,
    account,
    expandedMenuItems,
    setExpandedMenuItem,
    setLastClicked,
  } = props
  const { t: translate } = useTranslate()
  const toggleMenuOpen = () =>
    dispatch({ type: GENERAL_TOGGLE_MAIN_NAVIGATION })
  const isExpanded = expandedMenuItems.includes(entry.label)

  const handleListElementClick = () => {
    toggleMenuOpen()
    setLastClicked(entry)
  }

  const renderMenuEntry = () => {
    if (!entry.items) {
      return (
        <li className="m-b-5" role="menuitem" onClick={handleListElementClick}>
          <NavLink to={parsePath(entry.path, activePlatform, account)}>
            {translate(entry.label)}
          </NavLink>
        </li>
      )
    }

    return (
      <li className="m-b-5" role="menuitem">
        <button
          type="button"
          className={isExpanded ? "expandable expanded" : "expandable folded"}
          onClick={() => setExpandedMenuItem(entry.label)}
        >
          <span>{entry.label}</span>
          <span className="svgContainer">
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.175 0L5 3.81667L8.825 0L10 1.175L5 6.175L0 1.175L1.175 0Z"
                fill="#13266D"
              />
            </svg>
          </span>
        </button>
        {isExpanded && (
          <div
            className={["m-t-5", styles[`navigationDeep${depth + 1}`]].join(
              " "
            )}
          >
            <ul className="l-unstyled">
              {entry.items?.map(item => (
                <MenuFactory
                  setExpandedMenuItem={setExpandedMenuItem}
                  expandedMenuItems={expandedMenuItems}
                  key={item.label}
                  entry={item}
                  depth={depth + 1}
                  activePlatform={activePlatform}
                  setLastClicked={setLastClicked}
                  account={account}
                />
              ))}
            </ul>
          </div>
        )}
      </li>
    )
  }

  return !!entry.permissions ? (
    <Permissions {...entry.permissions}>{renderMenuEntry()}</Permissions>
  ) : (
    renderMenuEntry()
  )
}

MenuFactory.propTypes = {
  entry: PropTypes.object.isRequired,
  depth: PropTypes.number.isRequired,
  activePlatform: PropTypes.string.isRequired,
  account: PropTypes.number.isRequired,
}

function parsePath(path, platform, account) {
  return path.replace(":platform", platform).replace(":account", account)
}
